/** Заголовок шапки по пути (совпадения сверху вниз — сначала более специфичные). */
export function resolveLayoutTitle(pathname: string): string {
  if (pathname === '/' || pathname === '/weeks') return 'Недели';
  if (pathname === '/weeks/create') return 'Новая неделя';
  if (/\/weeks\/[^/]+\/setup(?:\/|\?|$)/.test(pathname)) return 'Настройка недели';
  if (/\/weeks\/[^/]+\/skills\/?$/.test(pathname)) return 'Выбор навыков';
  if (pathname.includes('/social-signals-tracking')) return 'Социальные сигналы';
  if (pathname.includes('/private-behaviors-tracking')) return 'Внутренние переживания';
  if (pathname.includes('/risk-factors-tracking')) return 'Факторы риска';
  if (pathname.includes('/radically-open-skills-tracking')) return 'Навыки РО';
  if (pathname.includes('/self-enquiry-tracking')) return 'Журнал самоисследования';
  if (/^\/weeks\/[^/]+$/.test(pathname)) return 'Неделя';
  if (pathname === '/tracker') return 'Трекер';
  if (pathname.startsWith('/journal')) return 'Журнал';
  if (pathname.startsWith('/self-enquiry/journal/')) return 'Запись';
  if (pathname === '/self-enquiry/history') return 'Журнал самоисследования';
  if (pathname.startsWith('/self-enquiry')) return 'Журнал самоисследования';
  if (pathname.startsWith('/archive/weeks/')) return 'Обзор недели';
  if (pathname.startsWith('/archive')) return 'Архив';
  if (pathname.startsWith('/profile')) return 'Профиль';
  if (pathname.startsWith('/settings/notifications')) return 'Уведомления';
  if (pathname.startsWith('/about')) return 'О проекте';
  return 'РО ДБТ';
}
